<template lang="pug">
  #app
    router-view
</template>
<script>
export default {
    data() {
        return {
            subscribe: false,
        }
    },
    computed: {
        pageInfo() {
            const title = this.$route.meta.title
            const { productBu } = this.$route.query
            return {
                title,
                productBu,
                shareInfo: {
                    title,
                    description: '点击查看详情',
                    image: window.location.href.split(/[?#]/)[0] + 'logo.jpg'
                }
            }
        }
    },
    async created() {
        this.$initSet(this.pageInfo)
    },
    watch: {
        '$route'() {
            // 更新追踪
            if (!this.$route.meta.noTrack) {
                this.$baseSetting(this.pageInfo)
            }
        }
    }
}
</script>
<style lang="scss">
</style>
